var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-alert"},[_c('div',{staticClass:"transparent-lightbox-bg"}),_c('div',{staticClass:"bloc-alert"},[_c('p',{staticClass:"error-content"},[_vm._v(" "+_vm._s(_vm.msg)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }